import { graphql, readInlineData } from 'react-relay';

import {
    type pricingGuidanceHelpers_item$key,
    type pricingGuidanceHelpers_item$data,
} from './__generated__/pricingGuidanceHelpers_item.graphql.ts';

const itemFragment = graphql`
    fragment pricingGuidanceHelpers_item on Item @inline {
        pricingGuidance(
            isTrade: $isTrade
            buyerId: $userId
            userCountryCode: $userCountryCode
            priceBookName: $priceBookName
        ) {
            price {
                convertedAmountList {
                    amount
                    currency
                }
            }
            medianAmount {
                convertedAmountList {
                    amount
                    currency
                }
            }
            minAmount {
                convertedAmountList {
                    amount
                    currency
                }
            }
            maxAmount {
                convertedAmountList {
                    amount
                    currency
                }
            }
        }
    }
`;

const getPriceAmountByCurrency = ({
    price,
    currency,
}: {
    price?: NonNullable<pricingGuidanceHelpers_item$data['pricingGuidance']>['price'];
    currency: string;
}): number => {
    const priceAmount = (price?.convertedAmountList || []).find(
        convertedAmount => convertedAmount?.currency === currency
    );

    return Math.floor(priceAmount?.amount || 0);
};

export const getPriceAmountByType = ({
    item: itemRef,
    currency,
    type,
}: {
    item: pricingGuidanceHelpers_item$key | null;
    currency: string;
    type: 'ITEM_PRICE' | 'MEDIAN' | 'MIN' | 'MAX';
}): number => {
    const item = readInlineData(itemFragment, itemRef);
    const { pricingGuidance } = item || {};
    const { price: itemPrice, medianAmount, minAmount, maxAmount } = pricingGuidance || {};
    let price;

    switch (type) {
        case 'ITEM_PRICE':
            price = itemPrice;
            break;
        case 'MEDIAN':
            price = medianAmount;
            break;
        case 'MIN':
            price = minAmount;
            break;
        case 'MAX':
            price = maxAmount;
            break;
    }

    return getPriceAmountByCurrency({ price, currency });
};
